<div class="d-flex">
  <i class="icon-ico_error_toast required-option-error-icon me-2"></i>
  <div class="required-option-errMsg">This Form is hidden from End users. It must not have any mandatory fields</div>
</div>
